import React from "react";
import { useDispatch, useSelector } from "react-redux";
import "./Popups.scss";
import { closePopup } from "../../../store/popups";
import UserDetailsPopup from "../../Registrations/UserDetailsPopup";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import RejectRequestPopup from "../../Registrations/RejectRequestPopup";
import EditUserDetailsPopup from "../../Registrations/EditUserDetailsPopup";
import PermissionAlertPopup from "../../Shared/Popups/PermissionAlertPopup";

const UnknownPopup = () => {
	return <div>Unknown Popup</div>;
};

const PopupComponent = ({ popup, props }) => {
	const Popup =
		{
			UserDetailsPopup,
			RejectRequestPopup,
			EditUserDetailsPopup,
			PermissionAlertPopup,
		}[popup] || UnknownPopup;

	return <Popup {...props} />;
};

export default function Popups() {
	const popupList = useSelector((state) => {
		return state.popups.list;
	});
	const dispatch = useDispatch();

	const popupStyles = {
		maxWidth: "90vw",
		minWidth: 285,
		maxHeight: 600,
		overflow: "scroll",
	};

	return (
		<>
			{popupList.map((info, index) => {
				const { popup, props, className, style = {} } = info;
				const handleFinish = (results = true) => {
					const { handleFinish, onFinish, onFinishHandler, onSubmit, onSuccess } = info.props;
					const submitHandler = handleFinish || onFinish || onSubmit || onSuccess || onFinishHandler;
					if (submitHandler) {
						submitHandler(results);
					}
					dispatch(closePopup({ popup, results, props }));
				};

				const handleClose = (e, results = undefined) => {
					dispatch(closePopup({ popup, results, props }));

					const { onCancel, onClose, onCancelHandler, onCloseHandler } = info.props || {};
					const cancelHandler = onCancel || onClose || onCancelHandler || onCloseHandler;
					if (cancelHandler) {
						cancelHandler(results);
					}
				};

				return (
					<div
						{...{
							className: `${className} custom-modal popupContainer`,
							style: { oveflow: "auto", ...style },
						}}
						{...{ show: true, key: index, handleClose: handleClose }}
					>
						<div id="popup-wrapper" style={popupStyles}>
							<div className="flex direction-col align-items-end">
								{props.hideCloseButton ? (
									<></>
								) : (
									<FontAwesomeIcon
										icon={faClose}
										size="xl"
										onClick={handleClose}
										style={{ cursor: "pointer" }}
									/>
								)}
							</div>
							<PopupComponent
								popup={popup}
								props={{
									...props,
									...{
										handleFinish,
										onFinish: handleFinish,
										onFinishHandler: handleFinish,
										onSubmit: handleFinish,
										onSuccess: handleFinish,

										handleClose,
										onCancel: handleClose,
										onClose: handleClose,
										onCancelHandler: handleClose,
										onCloseHandler: handleClose,
									},
								}}
							/>
						</div>
					</div>
				);
			})}
		</>
	);
}
